import React from 'react';
import ThemeToggle from '@/components/ThemeToggle';
import PopoutButton from '@/components/PopoutButton';
import LanguageSelector from '@/components/LanguageSelector';
import { useTerminalModeStore } from '@/stores/terminalMode.store';

const TopNavigation: React.FC = () => {
  const { mode, setMode } = useTerminalModeStore();
  
  return (
    <div className="bg-gray-800 text-white p-2 flex justify-between items-center">
      <div className="flex items-center space-x-4">
        <div className="text-lg font-bold">Terminal IDE</div>
        
        <div className="flex space-x-2">
          <button className="px-3 py-1 rounded hover:bg-gray-700">File</button>
          <button className="px-3 py-1 rounded hover:bg-gray-700">Edit</button>
          <button className="px-3 py-1 rounded hover:bg-gray-700">View</button>
          <button className="px-3 py-1 rounded hover:bg-gray-700">Terminal</button>
          <button className="px-3 py-1 rounded hover:bg-gray-700">Help</button>
        </div>
      </div>
      
      <div className="flex items-center space-x-3">
        <LanguageSelector />
        <ThemeToggle />
        
        <div className="ml-4">
          <select
            className="bg-gray-700 text-white text-sm px-2 py-1 rounded"
            value={mode}
            onChange={(e) => setMode(e.target.value)}
          >
            <option value="terminal">Terminal</option>
            <option value="shell">Shell</option>
            <option value="node">Node</option>
            <option value="python">Python</option>
          </select>
        </div>
        
        <PopoutButton />
      </div>
    </div>
  );
};

export default TopNavigation;